module.exports = {"home":{"introduce":"这是针对海外公司员工的手机服务。支持服务已通过<br />IKEN / KOLON邮件/ KOLON批准。","install":"安装","setting":"确保检查您的手机首选项！"},"setting":{"ios":{"phone_setting":"移动电话 设置","phone_desc":"从手机的设置菜单<br>转到<span> \"设置 \" 常规 \" 设备管理\"</span> 选择。","permit":"检查受信任的应用","permit_desc":"企业应用<br>科隆贝尼特有限公司<br />选择<span>[信任]</span>"},"android":{"notice":"安装时请使用Chrome浏览器。","setting":"选择设定","setting_desc":"如果出现安全警告，<br />请单击<span>[设置]</span>","permit":"检查访问权限设置","permit_desc":"Chrome应用程序<br />请打开<span>“允许此来源”</span>"}},"confirm":{"install":"\"KOLON Apps\" 설치하시겠습니까?_ch"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ch.json
// module id = 1ErE
// module chunks = 1